<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="Retour" default-href="#" (click)="close()"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content scroll-y="false">
  <ion-grid>
    @if (genericAppt) {
      <ion-row>
        @if (genericAppt.fr_commentaireappel) {
          <ion-col size="12">
            <strong>Commentaire prise d'appel :</strong>
          </ion-col>
        }
        @if (genericAppt.fr_commentaireappel) {
          <ion-col size="12">
            {{genericAppt.fr_commentaireappel}}
          </ion-col>
        }
        @if (genericAppt.fr_commentairepourpromoteur) {
          <ion-col size="12">
            <strong>Commentaire pour promoteur :</strong>
          </ion-col>
        }
        <ion-col size="12">
          {{genericAppt.fr_commentairepourpromoteur}}
        </ion-col>
      </ion-row>
    }
  </ion-grid>
</ion-content>
